import { v4 as uuidv4 } from 'uuid'
import helpers from '@/library/rpcService/api/helpers'

export default {
  overrideRequest: function (axiosConfig) {

  },

  settlebuyback: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.transformRequest = [(params, headers) => {
        headers['Idempotency-Key'] = uuidv4()
        return helpers.axiosTransformRequestHandler(params, headers)
      }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/BuyBack.js